export const formatearMensaje = (data) => {
    /*
     *Función para formatear un mensaje basado en un objeto de datos devuelto por la API.*
     @param {Object} data - Objeto con los datos devueltos por la API
     */
    let mensajeCompleto = "";

    // 1. Obtener las claves (nombres de los campos) del objeto del mensaje
    const campos = Object.keys(data);
    campos.forEach(campo => {
    // 2. Obtener la lista de mensajes para ese campo
    const datosDelCampo = data[campo];
    // 3. Formatear el nombre del campo para que sea más legible (opcional)
    // Ejemplo: 'producto' -> 'Producto'
    const nombreCampoFormateado = campo.charAt(0).toUpperCase() + campo.slice(1).replace(/_/g, ' ');

    // 4. Iterar sobre la lista de mensajes
    // Construir el mensaje final: "Campo: Mensaje "
    mensajeCompleto += `${nombreCampoFormateado}: ${datosDelCampo}\n`;
    });

    // Si no se encontraron errores específicos de campos, usar un mensaje genérico
    if (mensajeCompleto === "" && typeof data === 'string') {
    return data;
    } else if (mensajeCompleto === "") {
    return "Ha ocurrido un error desconocido al procesar la solicitud.";
    }

    return mensajeCompleto.trim();
};

export const clonarProfundo = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

export const parsearFechaHoraString = (fechaString) => {
  // 1. Validación por si el string viene vacío, nulo o indefinido
  if (!fechaString || typeof fechaString !== 'string') {
    return { fecha: '', hora: '' };
  }

  // 2. Intentar la conversión directa del string a objeto Date
  // Reemplazamos el espacio por una 'T' si viene en formato "YYYY-MM-DD HH:MM:SS" 
  // para que sea 100% compatible con todos los navegadores.
  const stringLimpio = fechaString.trim().replace(' ', 'T');
  const fecha = new Date(stringLimpio);
  
  // 3. Si el string no era una fecha válida (ej. "texto-cualquiera") devuelve vacío
  if (isNaN(fecha.getTime())) {
    return { fecha: '', hora: '' }; 
  }

  // 4. Extraer los componentes con ceros a la izquierda
  const dia = String(fecha.getDate()).padStart(2, '0');
  const mes = String(fecha.getMonth() + 1).padStart(2, '0'); 
  const anio = fecha.getFullYear();

  const horas = String(fecha.getHours()).padStart(2, '0');
  const minutos = String(fecha.getMinutes()).padStart(2, '0');
  const segundos = String(fecha.getSeconds()).padStart(2, '0');

  return {
    fecha: `${dia}/${mes}/${anio}`,       // "DD/MM/YYYY"
    hora: `${horas}:${minutos}:${segundos}` // "HH:MM:SS"
  };
};

export const formatToISO = (fecha) => {
  if (!fecha) return null;
  
  // Si la fecha contiene '/', la dividimos (ej: "31/08/2026")
  if (typeof fecha === 'string' && fecha.includes('/')) {
    const [dia, mes, anio] = fecha.split('/');
    return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
  }
  
  // Si ya viene formateada en YYYY-MM-DD la devuelve tal cual
  return fecha;
}